"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5689],{

/***/ 55689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    d: "M21 10C19 10 17.1 10.6 15.5 11.6C15.9 8.6 14.9 5.5 12.7 3.3C12.3 2.9 11.7 2.9 11.3 3.3C9 5.6 8.1 8.7 8.5 11.6C6.9 10.6 5 10 3 10C2.4 10 2 10.4 2 11C2 16.5 6.5 21 12 21C17.5 21 22 16.5 22 11C22 10.4 21.6 10 21 10ZM12 5.5C14.2 8.3 14.2 12.3 12 15.2C9.8 12.3 9.8 8.4 12 5.5ZM4.1 12.1C7.6 12.6 10.5 15.4 10.9 18.9C7.4 18.4 4.6 15.6 4.1 12.1ZM13.1 18.9C13.6 15.4 16.4 12.5 19.9 12.1C19.4 15.6 16.6 18.4 13.1 18.9Z"
}), "Wellness"));


/***/ })

}]);